export default class FloatingLabel {
    constructor (inputWrapperSelector) {
        this.WRAPPER_SELECTOR = inputWrapperSelector
        this.INPUT_WRAPPERS = document.querySelectorAll(this.WRAPPER_SELECTOR)
        this.init()
    }

    init () {
        if (this.INPUT_WRAPPERS.length < 1) {
            return
        }

        this.INPUT_WRAPPERS.forEach(INPUT_WRAP => {
            const INPUT = INPUT_WRAP.querySelector('input, select, textarea')

            if(INPUT){
                if (INPUT.value) {
                    INPUT_WRAP.classList.add('active')
                }

                if (INPUT.type === 'select-one' || INPUT.type === 'select-multiple') {
                    INPUT.addEventListener('change', event => this.handleClassName(event.target, INPUT_WRAP))
                } else {
                    INPUT.addEventListener('input', event => this.handleClassName(event.target, INPUT_WRAP))
                }
            }
        })
    }

    handleClassName (inputElem, inputWrap) {
        inputElem.value
            ? inputWrap.classList.add('active')
            : inputWrap.classList.remove('active')
    }

    reset () {
        this.INPUT_WRAPPERS.forEach(INPUT_WRAP => INPUT_WRAP.classList.remove('active'))
    }
}